import { useEffect, useState } from 'react'
import { GetUserWarehouseUseCase } from '../../usecases/GetUserWarehouseUseCase'
import { AxiosWarehouseRepository } from '../../infrastructure/AxiosWarehouseRepository'
import { Warehouse } from '../../domain/warehouse'

export interface WarehouseOption {
    value: string
    label: string
}

export function useWarehouse() {
    const [warehouse, setWarehouse] = useState<Warehouse[] | []>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchWarehouse = async () => {
            try {
                setLoading(true)
                const repository = new AxiosWarehouseRepository()
                const useCase = new GetUserWarehouseUseCase(repository)
                const data = await useCase.execute()
                setWarehouse(data.items)
                setError(null)
            } catch (err) {
                setError(
                    err instanceof Error
                        ? err.message
                        : 'Error al cargar warehouse'
                )
                setWarehouse([])
            } finally {
                setLoading(false)
            }
        }

        fetchWarehouse()
    }, [])

    const getWarehouseOptions = (): WarehouseOption[] => {
        if (warehouse.length === 0) return []

        return warehouse.map((item) => ({
            value: `${item.id}`,
            label: item.name,
        }))
    }

    return {
        warehouse,
        loading,
        error,
        options: getWarehouseOptions(),
    }
}
